<template>
<div class="amf-collection col-12">
    <div>
        <ul v-if="items.length > 0">
            <li v-for="item in items" :key="item.id">
                <div v-if="item.component">
                    <div :item="item" :is="item.component"></div>
                </div>
                <div v-else-if="item.action == 'Add'">
                    <a href="#" v-on:click.prevent="addItem.showModal(addItem)">
                    <span :class="['fa', 'fa-plus', 'mr-1']"></span>
                    {{ addItem.text }}
                    </a>
                </div>                
                <div v-else-if="item.action !== 'Add'">
                    <a
                        href="#"
                        v-on:click.prevent="editItem(item)"
                    >
                    <span :class="['fa', item.icon]"></span>
                    {{item.linkText || item.text}}</a>{{item.linkText ? item.text.slice(item.linkText.length) : ""}}
                </div>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    props: {
        items: Array,
        addItem: { type: Object, default: function () { return null; } },
        editItem: Function,
    },
    data() {
        return { };
    },
}
</script>

<style lang="scss" scoped>
    .amf-collection {
        ul {
            margin-bottom: 0;
            padding: 0;
            list-style-type: none;
        }
        li:not(:last-child) {
            margin-bottom: 0.75rem;
        }
        a {
            color: black;
        }
    }
</style>


// WEBPACK FOOTER //
// src/framework/primitives/AmfCollection.vue